import React, { useEffect, useRef, useState } from 'react';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import Sweetness from '../Assets/Sweetness.jpg';
import HomeHero from '../Assets/myhomehero_spotlightseries_img_1200x960_720.png';
import './KodenshaFreeToReadHome.scss';
import { Link } from '../../Devon/Components/InkyLink';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';
import { Spotlight } from '../../Models/Spotlight';
import { useWindowSize } from '../Hooks/useWindowSize';

interface KodanshaFreeProps {
    src: string;
    title: string;
    id: number | string;
    readerId: number;
    author: string;
    color: string;
    description: string;
    limit?: string;
    rest?: Spotlight;
}

const KodenshaFreeToReadHome = (props: KodanshaFreeProps): JSX.Element => {
    // const history = useHistory();
    const divRef = useRef(null);
    const { width } = useWindowSize();
    const [secondLine, setSecondLine] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            const div = divRef.current;
            const span = div.children[0].children[0].children[0];
            setSecondLine(false);

            if (span.scrollHeight > span.offsetHeight) {
                setSecondLine(true);
            } else {
                setSecondLine(false);
            }
        }, 10);
    }, [width]);

    console.log('props.color', props.color);

    return (
        <div className='offer-item-container'
             aria-label={'kodansha offer ' + props.title}>

            {props.limit && <span className={'limit-text'}>
                {props.limit}
            </span>}

            <Link to={'/series/' + props.rest.readableUrl} className={`link-series-poster`}>
                <SeriesPoster
                    preloadImage={true}
                    ratio={60}
                    src={props.src}
                    alt={props.title}
                    color={props.color}
                    s={{width: 366}}
                    m={{width: 339}}
                    l={{width: 440}}
                    xl={{width: 692}}
                />
            </Link>

            {/*<span className='description-text-offer'>{props.description}</span>*/}
            <div className='info-wrapper' style={{ flexDirection: secondLine ? 'column' : 'row' }}>
                <div className='name-author-wrapper'>
                    <Link to={'/series/' + props.rest.readableUrl} className='name-author-link'>
                        <span className='name' aria-label={'kodansha offer for ' + props.title}>{props.title}</span>
                    </Link>
                    <Link to={'/series/' + props.rest.readableUrl} className='name-author-link'>
                       <span className='author'
                             aria-label={'kodansha offer author ' + props.author}>By {props.author}</span>
                    </Link>
                </div>

                <div className='date-wrapper' ref={divRef}>
                    <Link
                        to={{ pathname: '/reader/' + props.readerId, state: { returnPath: '/' } }}
                        onClick={e => e.stopPropagation()}
                        aria-label={'kodansha offer ' + props.title}>
                        <KodanshaArrow
                            // text={props.title === 'Sweetness and Lightning' ? 'Read' : 'Read the text now'}
                            text={props.rest.buttonText ?? 'Read'}
                            aria-label={'read button for ' + props.title}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default React.memo(KodenshaFreeToReadHome);
